import { copyTextToClipboard } from '@affine/erp-ui';
import { type Clipboard as BlockStdScopeClipboard } from '@blocksuite/affine/std';

const clipboardWriteIsSupported =
  'clipboard' in navigator && 'write' in navigator.clipboard;

export const copyLinkToBlockStdScopeClipboard = async (
  text: string,
  clipboard?: BlockStdScopeClipboard
) => {
  let success = false;

  if (!clipboard) return success;

  if (clipboardWriteIsSupported) {
    try {
      await clipboard.writeToClipboard(items => ({
        ...items,
        'text/plain': text,
        // wrap a link
        'text/html': `<a href="${text}">${text}</a>`,
      }));
      success = true;
    } catch (error) {
      console.error(error);
    }
  }

  if (!success) {
    success = await copyTextToClipboard(text);
  }

  return success;
};
